import styled from "styled-components";
import { } from "../../../constants";

export const ActionLine = styled.div`
  clear: both;
  display: block;
  width: 100%;
  padding: 2rem;
`;
